import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import IMUtils from "../business/IMUtils";

class CustomHeaderComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        params = params || {};
        params.className = "CustomHeaderComponent";
        super(element, parentComponent, params);

        this.$el = $(element);
        this.isMaze = element.getAttribute('data-maze') === 'true';
        this.body = document.querySelector('body');
        this.menuMobileOpen = 'menu-open';
        this.menuMobileOpenClass = 'customHeader__menu--open';
        this.menuMobile = document.querySelector('.customHeader__menu');

        this.init();
    }

    init() {
        this.customFooter();
        this.menuMobileManager();
        this.innerPanel();
        this.customLink();
        this.searchManager();
        this.mazeNlPopup();
    }

    mazeNlPopup() {
        if (this.isMaze) IMUtils.initMazePopup();
    }

    customFooter() {
        let links = document.querySelectorAll('.customHeader .customHeader__link');
        let linksObj = {
            links: [...links].map(link => link.cloneNode(true).outerHTML).join('')
        };

        let customFooterHtml = `
            <div class="customFooter">
                <img class="customFooter__logo maze35-customLogo" src="/fe-web/img/marangoni/bcf/maze35-logo.svg" alt="Marangoni logo"/>
                <div class="customFooter__content">
                    <div class="customFooter__content-links">
                        <span class="customFooter__content-links-title">Categories</span>
                        ${linksObj.links}
                    </div>
                    <div class="customFooter__content-info">
                        <span class="customFooter__content-info-title">Info</span>
                        <a href="${KD_MARANGONI_SITE_CONSTANTS.MAZE_ABOUT}" class="customFooter__content-info-link">About Us</a>
                        <a href="${KD_MARANGONI_SITE_CONSTANTS.CONTACT_FORM}" class="customFooter__content-info-link">Submit</a>
                        <a href="${KD_MARANGONI_SITE_CONSTANTS.MAZE_TERMS}" class="customFooter__content-info-link">Terms of Use</a>
                        <a href="${KD_MARANGONI_SITE_CONSTANTS.PRIVACY_URL}" class="customFooter__content-info-link">Privacy</a>
                    </div>
                </div>
            </div>
        `;

        if (this.isMaze) {
            document.querySelector('footer').innerHTML = '';
            document.querySelector('footer').insertAdjacentHTML('afterbegin', customFooterHtml);
        }
    }

    customLink() {
        let customLink = document.querySelector('.customHeader__link-custom');

        customLink?.addEventListener('click', (e) => {
            document.querySelector('.customHeader__search-panel').classList.remove('visible');
            document.querySelector('.customHeader__topics').classList.toggle('visible');
        })

    }

    menuMobileManager() {
        document.querySelector('.customHeader__bar-icon')?.addEventListener('click', (e) => {
            this.menuMobile.classList.add(this.menuMobileOpenClass);
            this.body.classList.add(this.menuMobileOpen);
        });

        document.querySelector('.customHeader__menu-close')?.addEventListener('click', (e) => {
            this.menuMobile.classList.remove(this.menuMobileOpenClass);
            this.body.classList.remove(this.menuMobileOpen);
        });

        document.querySelectorAll('.customHeader__menu-info__title, .customHeader__menu-list__title, .customHeader__menu-topic__title').forEach(title => {
            title?.addEventListener('click', (e) => {
                e.target.nextElementSibling.classList.toggle('customHeader__menu-info--open');
            });
        });
    }

    innerPanel() {
        document.querySelectorAll('.customHeader__menu-manager').forEach(menu => {
            menu?.addEventListener('click', (e) => {
                let dataPanelOpener = menu.getAttribute('data-panel-opener');

                document.querySelectorAll('.customHeader__menu-manager').forEach(menuItem => menuItem.classList.remove('hidden'));
                document.querySelectorAll('.customHeader__panel').forEach(panel => panel.classList.add('hidden'));

                menu.classList.add('hidden');
                document.querySelector(`.customHeader__panel[data-panel=${dataPanelOpener}]`).classList.remove('hidden');
            });
        });
    }

    searchManager() {
        let search = document.querySelector('.customHeader__search');
        let searchInput = document.querySelector('.customHeader__search-input');
        let searchPanel = document.querySelector('.customHeader__search-panel');
        let searchMobile = document.querySelector('[data-panel-opener="search"]');
        let searchPanelMobile = document.querySelector('.customHeader__menu-search-wrapper');
        let searchInputMobile = document.querySelector('.customHeader__menu-search-wrapper input');
        let externalSearch = document.querySelector('.customHeader__bar-search');
        let innerMobileSearch = document.querySelector('.customHeader__menu-search.customHeader__menu-manager');
        let mobileIconSearch = document.querySelector('.customHeader__bar-icon');

        search?.addEventListener('click', (e) => {
            document.querySelector('.customHeader__topics').classList.remove('visible');
            searchPanel.classList.toggle('visible');

            searchPanel.classList.contains('visible')
                ? searchInput.focus()
                : searchInput.blur();
        });

        searchMobile?.addEventListener('click', (e) => {

            searchPanelMobile.classList.contains('hidden')
                ? searchInputMobile.blur()
                : searchInputMobile.focus();
        });

        externalSearch?.addEventListener('click', (e) => {
            mobileIconSearch.click();
            innerMobileSearch.click();
            innerMobileSearch.focus();
        });

    }
}

export default CustomHeaderComponent;